import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { IListHistoryLog } from "../Customer_V2/customerApi_V2";
export interface DataTypeBenefit {
    key?: number
    id?: number
    stt: number
    title: string
    description?: string
    status?: number
    code?: string
    benefitPolicyNames?: string
    dateStart?: string
    dateEnd?: string
    categoryCar?: string
}
export interface IBenefit {
    id: number
    title: string
    code: string
    description: string
    status: number
    categoryCar?: string
}
export interface IBenefitRank {
    rank: RankBenefit;
    listBenefit: ListBenefit[];
}
export interface ListBenefit {
    id: number;
    title: string;
    description: string;
}
export interface RankBenefit {
    title: string;
    icon: string;
}

export interface IInfoBenefit {
    id: number;
    title: string;
    code: string;
    description: string;
    categoryCar: {
        id: number,
        code: string,
        title: string,
    }[]
}
export const infoBenefit = async (
    id: number
) => {
    const path = "rank/infoBenefit"
    const params = {
        id
    }
    const result: ResponseSuccess<IInfoBenefit> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const infoBenefitPolicies = async (
    id: number
) => {
    const path = "rank/infoBenefitPolicies"
    const params = {
        id
    }
    const result: ResponseSuccess<IInfoBenefit> = await axiosClient.get(
        path, { params }
    );
    return result;
};


export const getListBenefitRank = async (
    id: number
) => {
    const path = "rank/listBenefitRank"
    const params = {
        id
    }
    const result: ResponseSuccessTotal<IBenefitRank> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const getListBenefit = async (
    limit?: number, pageNumber?: number, search?: string, sort?: number, type?: number
) => {
    const path = "rank/listBenefit"
    const params = {
        limit, pageNumber, search, sort, type
    }
    const result: ResponseSuccessTotal<IBenefit[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const getListBenefitsByCustomer = async (
    customerId: number, limit?: number, pageNumber?: number, search?: string,
) => {
    const path = "/rank/listBenefitsByCustomer"
    const params = {
        customerId, limit, pageNumber, search
    }
    const result: ResponseSuccessTotal<IBenefit[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};


export const getListBenefitPolicies = async (
    limit?: number, pageNumber?: number, search?: string, sort?: number, type?: number
) => {
    const path = "/rank/listBenefitPolicies"
    const params = {
        limit, pageNumber, search, sort, type
    }
    const result: ResponseSuccessTotal<IBenefit[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const getListBenefitPoliciesByCustomer = async (
    customerId: number, limit?: number, pageNumber?: number, search?: string,
) => {
    const path = "/rank/listBenefitPoliciesByCustomer"
    const params = {
        customerId, limit, pageNumber, search
    }
    const result: ResponseSuccessTotal<IBenefit[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};

export const getListHistoryCardIssuance = async (
    customerId?: number, limit?: number, pageNumber?: number,
    search?: string, dateStart?: string, dateEnd?: string
) => {
    const path = "/rank/listHistoryCardIssuance"
    const params = {
        customerId, limit, pageNumber,
        search, dateStart, dateEnd
    }
    const result: ResponseSuccessTotal<IListHistoryLog[]> = await axiosClient.get(
        path, { params }
    );
    return result;
};


export const addBenefit = async (
    code: string, title: string, description: string
) => {
    const path = "rank/addBenefit"
    const params = {
        code, title, description
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        path, params
    );
    return result;
};

export const addBenefitPolicies = async (
    code: string, title: string, description: string, listCategoryCar ?: number[]
) => {
    const path = "/rank/addBenefitPolicies"
    const params = {
        code, title, description, listCategoryCar
    }
    const result: ResponseSuccess<[]> = await axiosClient.post(
        path, params
    );
    return result;
};

export const updateActiveBenefit = async (
    id: number) => {
    const path = "rank/activeBenefit"
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, params
    );
    return result;
};

export const updateActiveBenefitPolicies = async (
    id: number) => {
    const path = "/rank/activeBenefitPolicies"
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, params
    );
    return result;
};

export const editBenefit = async (
    id: number, code: string, title: string, description: string) => {
    const path = "rank/editBenefit"
    const params = {
        id, code, title, description
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, params
    );
    return result;
};

export const editBenefitPolicies = async (
    id: number, code: string, title: string, description: string) => {
    const path = "/rank/editBenefitPolicies"
    const params = {
        id, code, title, description
    }
    const result: ResponseSuccess<[]> = await axiosClient.put(
        path, params
    );
    return result;
};

export const deleteBenefit = async (
    id: number
) => {
    const path = "rank/deleteBenefit"
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.delete(
        path, { params }
    );
    return result;
};


export const deleteBenefitPolicies = async (
    id: number
) => {
    const path = "/rank/deleteBenefitPolicies"
    const params = {
        id
    }
    const result: ResponseSuccess<[]> = await axiosClient.delete(
        path, { params }
    );
    return result;
};